import {mutation} from './store';
import {RoleData} from "@/types";

export const pushRoleData= mutation<RoleData[]>('brand-push-data', (state, payload) => {
	state.data = payload
})
